export const QUESTION_LIMITS = {
	BILL_NO_BILL: { min: 26, max: 26 },
	BILL_BECOMES_LAW: { min: 12, max: 12, noun: "Steps" },
	QUIZ: { min: 6, max: 6 },
	FINAL_GAME: { min: 15, max: 15 },
	CROSSWORD: { min: 10, max: 26 },
	MATHAHTZEE: { min: 26 },
	LOOSE_LINK: { min: 5 },
};

export const QUESTION_LIMIT_BY_GAME_KEY = {
	LegislativeBillNoBill: QUESTION_LIMITS.BILL_NO_BILL,
	"Bill No Bill History": QUESTION_LIMITS.BILL_NO_BILL,
	LegislativeBillBecomesLaw: QUESTION_LIMITS.BILL_BECOMES_LAW,
	QuizQuestions: QUESTION_LIMITS.QUIZ,
	"Foreign Language Quiz": QUESTION_LIMITS.QUIZ,
	"Quizardy Foreign Language": QUESTION_LIMITS.QUIZ,
	FinalGameQuestion: QUESTION_LIMITS.FINAL_GAME,
	crossWord: QUESTION_LIMITS.CROSSWORD,
	Crossword: QUESTION_LIMITS.CROSSWORD,
	Mathahtzee: QUESTION_LIMITS.MATHAHTZEE,
	"Loose Link": QUESTION_LIMITS.LOOSE_LINK,
};

export function getQuestionCount(count) {
	if (Array.isArray(count)) {
		return count.length;
	}

	const numericCount = Number(count);
	return Number.isFinite(numericCount) ? numericCount : 0;
}

export function getQuestionCountMessage(count, limits = {}) {
	const added = getQuestionCount(count);
	const { min, max, noun = "Questions" } = limits;

	if (typeof max === "number" && typeof min === "number" && min === max) {
		return `${noun} added: ${added} of ${max}`;
	}
	if (typeof max === "number" && typeof min === "number") {
		return `${noun} added: ${added} of ${max} (minimum ${min} required)`;
	}
	if (typeof max === "number") {
		return `${noun} added: ${added} of ${max}`;
	}
	if (typeof min === "number") {
		return `${noun} added: ${added} (minimum ${min} required)`;
	}

	return `${noun} added: ${added} (no maximum)`;
}

export function isQuestionMaxReached(count, max) {
	if (typeof max !== "number") {
		return false;
	}

	return getQuestionCount(count) >= max;
}

export function withQuestionLimitDisabled(existingDisabled, count, max) {
	return Boolean(existingDisabled) || isQuestionMaxReached(count, max);
}

export function getQuestionLimitForGame(gameKey) {
	return QUESTION_LIMIT_BY_GAME_KEY[gameKey] || {};
}
